import React from 'react';
import styled from 'styled-components';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import { MEDIA } from '@constants';
import Colors from '../Colors';

interface Props {
  pills: string[];
  backgroundColor?: string;
  textColor?: string;
  textVariant?: TextVariant;
  textMobileVariant?: TextVariant;
}

const PillsGrid: React.FC<Props> = ({
  pills,
  backgroundColor = Colors.paleGold50,
  textColor = Colors.navyBlue,
  textVariant = TextVariant.BodyRegularLG,
  textMobileVariant = TextVariant.BodyRegularSM
}) => {
  if (!pills?.length) return null;

  return (
    <StyledPillsGrid>
      {pills.map((pill) => (
        <StyledPill key={pill} $backgroundColor={backgroundColor}>
          <Typography $variant={textVariant} $mobileVariant={textMobileVariant} $color={textColor}>
            {pill}
          </Typography>
        </StyledPill>
      ))}
    </StyledPillsGrid>
  );
};

export default PillsGrid;

const StyledPillsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const StyledPill = styled.div<{ $backgroundColor: string }>`
  padding: 4px 12px;
  align-items: center;
  border-radius: 20px;
  background: ${({ $backgroundColor }) => $backgroundColor};
  backdrop-filter: blur(5px);

  ${MEDIA.tablet} {
    padding: 4px 8px;
  }
`;
